import { render } from "./SemifraniaMenuComponent.vue?vue&type=template&id=9e63edbc&scoped=true"
import script from "./SemifraniaMenuComponent.vue?vue&type=script&lang=js"
export * from "./SemifraniaMenuComponent.vue?vue&type=script&lang=js"

import "./SemifraniaMenuComponent.vue?vue&type=style&index=0&id=9e63edbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e63edbc"]])

export default __exports__